import injectSheet from 'react-jss';

import ColorScale from './component';
import styles from './styles';

export default injectSheet(styles)(ColorScale);
